import React, { useState, useEffect } from 'react'
import classNames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'

import classes from './leaderboard.module.css'
import { getLeaderboard } from '../dashboardApi'
import { dashboardSelectors } from '../dashboardSlice'
import notification from '../../../components/Notification/notification'
import Spinner from '../../../components/loaders/Spinner'
import Drawer from './Drawer'

const LeaderBoard = () => {
    const [isViewMoreModalVisiblee, setIsViewMoreModalVisible] = useState(false)
    const dispatch = useDispatch()
    const leaderboardData = useSelector(dashboardSelectors.leaderboard).data
    const isFetchingLeaderboard = useSelector(dashboardSelectors.isFetching)
        .leaderboard
    const leaderboardErrorMessage = useSelector(dashboardSelectors.errorMessage)
        .leaderboard
    const leaderboardHasError = useSelector(dashboardSelectors.hasError)
        .leaderboard
    const backgroundColors = [
        'linear-gradient(91.27deg, #ED474B 6.09%, #F37378 95.2%)',
        'linear-gradient(91.27deg, #4666F6 6.09%, #A8B6F6 95.2%)',
        'linear-gradient(91.27deg, #72AD79 6.09%, #A4EBAC 95.2%)',
        'linear-gradient(91.27deg, #ECB344 6.09%, #FCDB9B 95.2%)',
        'linear-gradient(91.27deg, #F2A9D1 6.09%, #FFD4EB 95.2%)',
    ]

    useEffect(() => {
        dispatch(getLeaderboard())
    }, [])

    useEffect(() => {
        if (leaderboardHasError) {
            notification.failure({
                title: 'Failed to load leader board',
                description: leaderboardErrorMessage,
            })
        }
    }, [leaderboardHasError])

    const nth = n =>
        ['st', 'nd', 'rd'][((((n + 90) % 100) - 10) % 10) - 1] || 'th'

    const renderLeader = (user, index) => {
        return (
            <div className={classNames('row', classes.leaderContainer)}>
                <div className="col-sm-12">
                    <div
                        className={classes.leaderboard}
                        style={{ background: backgroundColors[index % 5] }}
                    >
                        <div className="row d-flex justify-content-between">
                            <div
                                className={classNames(
                                    classes.position,
                                    'col-6 col-sm-2'
                                )}
                            >
                                {`${index + 1}${nth(index + 1)}`}
                            </div>
                            <div className="col-6 col-sm-4 d-flex align-items-end align-items-sm-start flex-column">
                                <span className={classes.name}>
                                    {user.beneficiary}
                                </span>
                                <span className={classes.timeSpent}>
                                    {user.timeSpent}
                                </span>
                            </div>
                            <div className="col-6 col-sm-3">
                                <span
                                    className={classes.numberOfCompletedCourses}
                                >
                                    {`${user.totalCompletedCourses} / ${user.totalCourses}`}
                                </span>
                            </div>
                            <div className={classes.avatar}>
                                {user.profilePicture && (
                                    <img src={user.profilePicture} alt="user" />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className={classes.container}>
            {isFetchingLeaderboard ? (
                <Spinner />
            ) : (
                <>
                    <div
                        className={classNames(
                            'row d-flex justify-content-between',
                            classes.header
                        )}
                    >
                        <div className="col">
                            <span className={classes.title}>Leaderboard</span>
                        </div>
                        <div
                            className="col"
                            style={{ flex: 'auto', maxWidth: 'max-content' }}
                        >
                            <span
                                className={classes.viewAll}
                                onClick={() => setIsViewMoreModalVisible(true)}
                            >
                                View all
                            </span>
                        </div>
                    </div>
                    <div className={classes.leaderboardContainer}>
                        {leaderboardData?.top5Beneficiaries
                            ?.slice(0, 5)
                            ?.map((item, index) => renderLeader(item, index))}
                    </div>
                </>
            )}
            <Drawer
                open={isViewMoreModalVisiblee}
                onClose={() => setIsViewMoreModalVisible(false)}
                data={leaderboardData?.top5Beneficiaries || []}
            />
        </div>
    )
}

export default LeaderBoard
